<template>
	<div class="link-form-item" :class="{'link-form-item-full-width':fullWidth,'link-form-item-invalidate':!!validateMessage}">
		<div class="link-form-item-wrapper" :class="classes">
			<div class="link-form-item-label" :style="labelStyles" v-if="!!p_label">
				<span v-if="!!p_required || required" class="link-form-item-label-required-tag">*&nbsp;</span>
				<span ref="label"><slot name="label">{{p_label}}</slot></span>
			</div>
			<div class="link-form-item-content">
				<slot></slot>
				<div class="link-form-item-validate-message" v-if="!!validateMessage && validateMessage!=='不能为空！'">
					{{validateMessage}}
				</div>
			</div>
		</div>
		<div class="link-form-item-external">
			<slot name="external"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: "link-form-item",
		props: {
			label: {},
			long: {type: Boolean},
			alignStart: {type: Boolean},
			fullWidth: {type: Boolean},

			prop: {type: [String, Array]},						// 校验的字段，可以是数组
			rules: {type: [Object, Array]},						// 校验规则，可以是数组，如果prop是数组，rules中每一个规则都必须指定prop
			required: {type: Boolean},							// 必填校验，如果prop是数组，rules会自动添加每一个field的必填校验规则
		},
		provide() {
			return {
				formItem: this,
			}
		},
		inject: {
			formColumn: {default: null},
			dialog: {default: null},
			linkForm: {default: null},
		},
		data() {
			return {
				labelWidth: null,
				p_required: false,
			}
		},
		watch: {
			label: {
				immediate: true,
				async handler(val) {
					await this.$lv.nextTick()
					let labelWidth = !!val ? this.$refs.label.offsetWidth : null
					if (!!this.p_required || this.required) labelWidth += 10
					this.labelWidth = labelWidth
				},
			}
		},
		computed: {
			p_label() {
				if (this.label == null) return null
				if (this.label.trim() === '') return this.label
				let label = this.label
				if (([':', '：'].indexOf(label.charAt(label.length - 1))) > -1) {
					label = label.slice(0, -1)
				}
				return label + '：'
			},
			labelStyles() {
				if (!this.formColumn) return null
				const styles = {}
				styles.width = this.$lv.$utils.unit(this.formColumn.lv_labelWidth)
				return styles
			},
			classes() {
				return {
					'link-form-item-long': !!this.long,
					'link-form-item-align-start': this.alignStart,
				}
			},

			validateMessage() {
				if (!this.linkForm) return null
				let props = Array.isArray(this.prop) ? this.prop : [this.prop]
				for (let i = 0; i < props.length; i++) {
					const prop = props[i];
					let message = this.linkForm.p_validateResult[prop]
					if (!!message) return message
				}
				return null
			},
		},
		created() {
			!!this.formColumn && this.formColumn.addItem(this)

			if (!!this.dialog) {
				this.onDialogShow = async () => {
					await this.$lv.nextTick()
					if (!this.$refs.label) return
					let labelWidth = this.$refs.label.offsetWidth
					if (!!this.p_required || this.required) labelWidth += 10
					this.labelWidth = labelWidth
				}
				this.dialog.$on('open', this.onDialogShow)
			}

			if (!!this.linkForm) {
				this.linkForm.addItem(this)
			}
		},
		beforeDestroy() {
			!!this.formColumn && this.formColumn.removeItem(this)
			if (!!this.dialog) {
				this.dialog.$off('input', this.onDialogShow)
			}
			if (!!this.linkForm) {
				this.linkForm.removeItem(this)
			}
		},
	}
</script>

<style lang="scss">
	@include themeify {
		.link-form-item-wrapper {
			display: inline-flex;
			align-items: center;
			justify-content: flex-start;
			box-sizing: border-box;
			min-height: 28px;
			width: 100%;

			&.link-form-item-long {
				width: 100% !important;
				justify-content: flex-start;
			}

			&.link-form-item-align-start {
				align-items: flex-start;
			}
		}
		.link-form {
			.link-form-item {
				&.link-form-item-full-width {
					width: 100% !important;
				}

				.link-form-item-wrapper {
					.link-form-item-label {
						text-align: right;
						display: inline-block;
						font-size: 12px;
						color: #262626;
					}

					.link-form-item-label-required-tag {
						color: pl-var(color-error);
						margin-right: 3px;
					}

					.link-form-item-content {
						display: inline-flex;
						align-items: center;
						flex: 1;
						flex-shrink: 0;
						color: #595959;
						font-size: 12px;
						position: relative;

						& > .link-icon {
							color: #8c8c8c;
						}

						& > *:not(:last-child) {
							margin-right: 6px;
						}

						.link-form-item-validate-message {
							position: absolute;
							bottom: -20px;
							left: 0;
							font-size: 12px;
							color: rgba($color-error, 0.7);
							white-space: nowrap;
							overflow: visible;
						}
					}
				}
			}
		}

		.link-form:not(.el-form) {
			.el-input {
				width: 200px;
			}

			.el-input-number {
				width: initial;
				font-size: 12px;

				.el-input {
					width: initial;

					.el-input__inner {
						width: 88px;
					}
				}

				.el-input-number__decrease, .el-input-number__increase {
					width: 22px;
					font-size: 12px;
				}
			}

			.el-checkbox__label {
				font-size: 12px;
				line-height: 12px;
			}

			.link-form-item-invalidate {
				.el-input input, .el-date-editor.el-range-editor.el-input__inner {
					border-color: $color-error;
				}
			}
		}

		.link-form-item {
			/*.el-input-number {
				.el-input-number__decrease {
					bottom: 2px;
					height: initial;
					left: 2px;
				}

				.el-input-number__increase {
					bottom: 2px;
					height: initial;
				}
			}*/
		}
	}
</style>
